import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface BarbersProps {
  onBookClick: () => void;
}
const barbers = [{
  name: 'Marcus Chen',
  specialty: 'Precision Fades',
  image: 'linear-gradient(135deg, #1A3D2F 0%, #0B0B0B 100%)'
}, {
  name: 'James Wilson',
  specialty: 'Classic Cuts',
  image: 'linear-gradient(135deg, #2A4D3F 0%, #0B0B0B 100%)'
}, {
  name: 'David Rodriguez',
  specialty: 'Beard Specialist',
  image: 'linear-gradient(135deg, #1A3D2F 0%, #0B0B0B 100%)'
}];
export function Barbers({
  onBookClick
}: BarbersProps) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  return <section id="barbers" className="py-32 px-6 bg-gradient-to-b from-matte-black to-deep-green/10" data-id="element-14">
      <div className="max-w-7xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-off-white mb-4" data-id="element-17">
            Master Barbers
          </h2>
          <p className="font-inter text-lg text-off-white/60" data-id="element-18">
            Experienced craftsmen dedicated to your style
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-19">
          {barbers.map((barber, index) => <motion.div key={barber.name} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} onHoverStart={() => setHoveredIndex(index)} onHoverEnd={() => setHoveredIndex(null)} className="relative group" data-id="element-20">
              <div className="relative overflow-hidden rounded-2xl aspect-[3/4] mb-6" data-id="element-21">
                <motion.div animate={{
              scale: hoveredIndex === index ? 1.1 : 1
            }} transition={{
              duration: 0.6,
              ease: 'easeOut'
            }} className="w-full h-full" style={{
              background: barber.image,
              filter: 'grayscale(100%)'
            }} data-id="element-22" />

                <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: hoveredIndex === index ? 1 : 0
            }} transition={{
              duration: 0.4
            }} className="absolute inset-0 bg-gradient-to-t from-matte-black via-matte-black/50 to-transparent flex flex-col items-center justify-end p-8" data-id="element-23">
                  <h3 className="font-playfair text-3xl font-bold text-off-white mb-2" data-id="element-24">
                    {barber.name}
                  </h3>
                  <p className="font-inter text-soft-gold mb-6" data-id="element-25">
                    {barber.specialty}
                  </p>
                  <motion.button onClick={onBookClick} whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="px-8 py-3 rounded-full bg-soft-gold text-matte-black font-inter font-bold hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] transition-shadow" data-id="element-26">
                    Book with {barber.name.split(' ')[0]}
                  </motion.button>
                </motion.div>
              </div>

              <div className="text-center md:opacity-100 opacity-100" data-id="element-27">
                <h3 className="font-playfair text-2xl font-bold text-off-white mb-1" data-id="element-28">
                  {barber.name}
                </h3>
                <p className="font-inter text-soft-gold" data-id="element-29">{barber.specialty}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}